import React, { useState, useEffect, useRef } from 'react';
import cl from './Style.module.css';
import AdminService from '../../API/AdminService';
import UserService from '../../API/UserService';
import { FOLDER_PROFILE, USER_addres } from '../../API/API'
import Spinner from '../../components/UI/Spinner/Spinner';
import axios from "axios";
import logger from '../../utils/logger';
import PageIntro from '../../components/PageIntro/PageIntro';
import {
    IconAccounts, IconGamepad, IconSearch, IconClose, IconCheck, IconAlert,
    IconChevronUp, IconChevronDown, IconRefresh, IconUser,
} from '../../components/Icons';

import ava from './img/ava.png'
import diamond from './img/16.png'
import rating from './img/rating_3.png'

// SVG-стрелки сортировки — заменяют unicode ↕↑↓
function SortIcon({ active, dir }) {
    if (!active) {
        return (
            <span style={{
                display: 'inline-flex', flexDirection: 'column', marginLeft: 4,
                color: 'var(--sk-content-text-muted)', opacity: 0.6,
            }}>
                <IconChevronUp width={9} height={9}/>
                <IconChevronDown width={9} height={9} style={{ marginTop: -2 }}/>
            </span>
        );
    }
    return (
        <span style={{ display: 'inline-flex', marginLeft: 4, color: '#b08620' }}>
            {dir === 'asc' ? <IconChevronUp width={12} height={12}/> : <IconChevronDown width={12} height={12}/>}
        </span>
    );
}

const AccountStufents = () => {
    // Состояния данных
    const topRef = useRef(null);
    const [students, setStudents] = useState([]);
    const [accountStudents, setAccountStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Состояния поиска и сортировки
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    // Состояния модальных окон
    const [showModal, setShowModal] = useState(false);
    const [editConnectionModal, setEditConnectionModal] = useState(false);
    const [showDisconnectConfirm, setShowDisconnectConfirm] = useState(false);

    const [selectedStudent, setSelectedStudent] = useState(null);
    const [selectedConnection, setSelectedConnection] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectedMinecraftAccount, setSelectedMinecraftAccount] = useState(null);
    const [isSearching, setIsSearching] = useState(false);
    const [isConnecting, setIsConnecting] = useState(false);
    const [isDisconnecting, setIsDisconnecting] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    // Состояния для данных майнкрафтии
    const [minecraftProfiles, setMinecraftProfiles] = useState({});

    // Состояния уведомлений
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationStatus, setNotificationStatus] = useState('success'); // 'success' or 'error'

    // Загрузка данных при монтировании
    useEffect(() => {
        loadData();
    }, []);

    // Поиск с дебаунсом
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (searchQuery.trim() && (showModal || editConnectionModal)) {
                handleSearch();
            } else {
                setSearchResults([]);
            }
        }, 300);

        return () => clearTimeout(timeoutId);
    }, [searchQuery, showModal, editConnectionModal]);

    useEffect(() => {
        if (topRef.current) {
            topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [showModal, editConnectionModal]);

    // Фильтрация студентов
    useEffect(() => {
        if (!searchTerm) {
            setFilteredStudents(students);
            return;
        }

        const filtered = students.filter(student => {
            const searchLower = searchTerm.toLowerCase();
            const connection = getAccountConnection(student.id);
            const minecraftProfile = connection ? minecraftProfiles[connection.idUserMinecraftia] : null;

            return (
                student.ferstName?.toLowerCase().includes(searchLower) ||
                student.lastName?.toLowerCase().includes(searchLower) ||
                student.age?.toString().toLowerCase().includes(searchLower) ||
                student.status?.toLowerCase().includes(searchLower) ||
                minecraftProfile?.firstName?.toLowerCase().includes(searchLower) ||
                (connection ? 'подключен' : 'не подключен').includes(searchLower)
            );
        });

        setFilteredStudents(filtered);
    }, [searchTerm, students, accountStudents, minecraftProfiles]);

    // Функция показа уведомлений
    const showNotificationMessage = (message, status = 'success') => {
        setNotificationMessage(message);
        setNotificationStatus(status);
        setShowNotification(true);

        // Автоскрытие через 5 секунд
        setTimeout(() => {
            setShowNotification(false);
        }, 5000);
    };

    // Функция сортировки
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });

        const sortedStudents = [...filteredStudents].sort((a, b) => {
            let aValue, bValue;

            switch (key) {
                case 'name':
                    aValue = `${a.ferstName || ''} ${a.lastName || ''}`.trim();
                    bValue = `${b.ferstName || ''} ${b.lastName || ''}`.trim();
                    break;
                case 'age':
                    aValue = parseInt(a.age) || 0;
                    bValue = parseInt(b.age) || 0;
                    break;
                case 'connection':
                    const connectionA = getAccountConnection(a.id);
                    const connectionB = getAccountConnection(b.id);
                    aValue = connectionA ? '1' : '0';
                    bValue = connectionB ? '1' : '0';
                    break;
                default:
                    aValue = a[key] || '';
                    bValue = b[key] || '';
            }

            if (key === 'age') {
                return direction === 'asc' ? aValue - bValue : bValue - aValue;
            } else {
                return direction === 'asc'
                    ? aValue.toString().localeCompare(bValue.toString(), 'ru', { numeric: true })
                    : bValue.toString().localeCompare(aValue.toString(), 'ru', { numeric: true });
            }
        });

        setFilteredStudents(sortedStudents);
    };

    // Иконка сортировки — SVG-стрелки
    const getSortIcon = (key) => (
        <SortIcon active={sortConfig.key === key} dir={sortConfig.direction}/>
    );

    // Загрузка всех данных
    const loadData = async () => {
        setLoading(true);
        setError('');

        try {
            const [studentsResponse, accountsResponse] = await Promise.all([
                AdminService.getAllStudents(),
                AdminService.getAllAccountStudents()
            ]);

            const studentsData = studentsResponse.data || [];
            const accountsData = accountsResponse.success ? accountsResponse.data : [];

            setStudents(studentsData);
            setAccountStudents(accountsData);
            setFilteredStudents(studentsData);

            await loadMinecraftProfiles(accountsData);

        } catch (error) {
            logger.error('Ошибка загрузки данных:', error);
            setError('Ошибка загрузки данных. Попробуйте обновить страницу.');
        } finally {
            setLoading(false);
        }
    };

    // Проверка, подключен ли аккаунт майнкрафтии к другому ученику
    const isAccountAlreadyConnected = (minecraftAccountId, excludeStudentId = null) => {
        return accountStudents.find(account =>
            account.idUserMinecraftia === minecraftAccountId &&
            (excludeStudentId ? account.idStudent !== excludeStudentId : true)
        );
    };

    // Получить информацию о студенте по подключенному аккаунту майнкрафтии
    const getStudentByConnection = (minecraftAccountId) => {
        const connection = accountStudents.find(acc => acc.idUserMinecraftia === minecraftAccountId);
        if (connection) {
            return students.find(student => student.id === connection.idStudent);
        }
        return null;
    };

    // Загрузка профилей Майнкрафтии одним bulk-запросом.
    // Раньше тут был цикл с двумя async-вызовами на каждый аккаунт —
    // 60 запросов для 30 учеников. Теперь 1 запрос к админ-сервису,
    // который сам решает, что вернуть (демо или прокси к user-сервису).
    const loadMinecraftProfiles = async (accounts) => {
        const ids = accounts
            .map(a => a.idUserMinecraftia)
            .filter(id => id != null);
        if (ids.length === 0) {
            setMinecraftProfiles({});
            return;
        }
        const profiles = await UserService.getProfilesBulk(ids);
        setMinecraftProfiles(profiles);
    };

    // Проверка подключения аккаунта для студента
    const getAccountConnection = (studentId) => {
        return accountStudents.find(account => account.idStudent === studentId);
    };

    // Обработка поиска пользователей майнкрафтии
    const handleSearch = async () => {
        if (!searchQuery.trim()) {
            setSearchResults([]);
            return;
        }

        setIsSearching(true);

        try {
            const response = await UserService.searchUsers(searchQuery);

            // Bulk-загрузка профилей (diamond, rating) одним запросом
            // вместо N×getProfileData.
            const ids = (response.data || []).map(u => u.id).filter(Boolean);
            const profiles = await UserService.getProfilesBulk(ids);
            const usersWithData = (response.data || []).map(user => {
                const p = profiles[user.id] || {};
                return {
                    ...user,
                    diamond: p.diamond || 0,
                    rating: p.rating || 0,
                };
            });

            setSearchResults(usersWithData);
        } catch (error) {
            logger.error('Ошибка поиска пользователей:', error);
            setSearchResults([]);
        } finally {
            setIsSearching(false);
        }
    };

    // Открытие модального окна подключения
    const openConnectModal = (student) => {
        setSelectedStudent(student);
        setShowModal(true);
        setSearchQuery('');
        setSearchResults([]);
        setSelectedMinecraftAccount(null);
    };

    // Открытие модального окна управления подключением
    const openEditConnectionModal = (student) => {
        const connection = getAccountConnection(student.id);
        setSelectedStudent(student);
        setSelectedConnection(connection);
        setEditConnectionModal(true);
        setSearchQuery('');
        setSearchResults([]);
        setSelectedMinecraftAccount(null);
        setShowDisconnectConfirm(false);
    };

    // Закрытие всех модальных окон
    const closeAllModals = () => {
        setShowModal(false);
        setEditConnectionModal(false);
        setShowDisconnectConfirm(false);
        setSelectedStudent(null);
        setSelectedConnection(null);
        setSearchQuery('');
        setSearchResults([]);
        setSelectedMinecraftAccount(null);
    };

    // Выбор аккаунта майнкрафтии
    const selectMinecraftAccount = (account) => {
        setSelectedMinecraftAccount(account);
    };

    // Подключение аккаунта
    // const connectAccount = async () => {
    //     if (!selectedStudent || !selectedMinecraftAccount) return;
    //     setShowModal(false)
    //     // ✅ НОВАЯ ПРОВЕРКА НА ДУБЛИРОВАНИЕ
    //     const existingConnection = isAccountAlreadyConnected(selectedMinecraftAccount.id);
    //     if (existingConnection) {
    //         const connectedStudent = getStudentByConnection(selectedMinecraftAccount.id);
    //         showNotificationMessage(
    //             `❌ Аккаунт "${selectedMinecraftAccount.firstName}" уже подключен к ученику "${connectedStudent?.ferstName} ${connectedStudent?.lastName}". Один аккаунт может быть подключен только к одному ученику.`,
    //             'error'
    //         );
    //         return;
    //     }

    //     setIsConnecting(true);

    //     try {
    //         const response = await AdminService.createAccountStudent({
    //             idStudent: selectedStudent.id,
    //             idUserMinecraftia: selectedMinecraftAccount.id
    //         });

    //         if (response.success) {
    //             closeAllModals();
    //             showNotificationMessage(
    //                 `✅ Аккаунт "${selectedMinecraftAccount.firstName}" успешно подключен к ученику "${selectedStudent.ferstName} ${selectedStudent.lastName}"!`,
    //                 'success'
    //             );
    //             await loadData();
    //         } else {
    //             showNotificationMessage(
    //                 '❌ Ошибка при подключении аккаунта: ' + (response.message || 'Неизвестная ошибка'),
    //                 'error'
    //             );
    //         }
    //     } catch (error) {
    //         logger.error('Ошибка подключения аккаунта:', error);
    //         showNotificationMessage('❌ Ошибка при подключении аккаунта. Попробуйте еще раз.', 'error');
    //     } finally {
    //         setIsConnecting(false);
    //     }
    // };

    // ✅ ПРАВИЛЬНАЯ ВЕРСИЯ
    const connectAccount = async () => {
        if (!selectedStudent || !selectedMinecraftAccount) return;

        // ❌ НЕ закрывай модальное окно в начале!
        // setShowModal(false) 

        // ✅ НОВАЯ ПРОВЕРКА НА ДУБЛИРОВАНИЕ
        const existingConnection = isAccountAlreadyConnected(selectedMinecraftAccount.id);
        if (existingConnection) {
            const connectedStudent = getStudentByConnection(selectedMinecraftAccount.id);
            showNotificationMessage(
                `❌ Аккаунт "${selectedMinecraftAccount.firstName}" уже подключен к ученику "${connectedStudent?.ferstName} ${connectedStudent?.lastName}". Один аккаунт может быть подключен только к одному ученику.`,
                'error'
            );
            return;
        }

        setIsConnecting(true);
        try {
            logger.log('[CONNECT ACCOUNT] 🔗 Шаг 1: Создание привязки в AccountStudents');

            // ✅ ШАГ 1: Создаем запись в AccountStudents
            const response = await AdminService.createAccountStudent({
                idStudent: selectedStudent.id,
                idUserMinecraftia: selectedMinecraftAccount.id
            });

            if (!response.success) {
                logger.error('[CONNECT ACCOUNT] ❌ Ошибка на шаге 1:', response.message);
                showNotificationMessage(
                    '❌ Ошибка при подключении аккаунта: ' + (response.message || 'Неизвестная ошибка'),
                    'error'
                );
                return;
            }

            logger.log('[CONNECT ACCOUNT] ✅ Шаг 1 завершен. Данные:', response.data);

            // ✅ ШАГ 2: Активируем подписку в микросервисе USER (КРИТИЧНО!)
            logger.log('[CONNECT ACCOUNT] 🔗 Шаг 2: Активация подписки в микросервисе');

            try {
                const token = localStorage.getItem('Authorization');
                const activateResponse = await axios.post(
                    USER_addres + '/api/v1/subscribe/minecraft/activate',
                    { minecraftUserId: selectedMinecraftAccount.id },
                    { headers: { 'Authorization': token } }
                );

                logger.log('[CONNECT ACCOUNT] ✅ Шаг 2 завершен. Ответ:', activateResponse.data);

                if (!activateResponse.data.success) {
                    logger.warn('[CONNECT ACCOUNT] ⚠️ Ответ активации:', activateResponse.data);
                }
            } catch (activateError) {
                logger.error('[CONNECT ACCOUNT] ❌ Ошибка активации подписки:', activateError);
                // Не прерываем процесс - запись уже создана
                showNotificationMessage(
                    '⚠️ Аккаунт подключен, но ошибка при активации подписки. Попробуйте обновить страницу.',
                    'error'
                );
            }

            // ✅ ШАГ 3: Показываем успешное сообщение и закрываем модальное окно
            closeAllModals(); // ТЕПЕРЬ закрываем ПОСЛЕ завершения
            showNotificationMessage(
                `✅ Аккаунт "${selectedMinecraftAccount.firstName}" успешно подключен к ученику "${selectedStudent.ferstName} ${selectedStudent.lastName}"!`,
                'success'
            );

            // ✅ ШАГ 4: Перезагружаем данные
            await loadData();

        } catch (error) {
            logger.error('[CONNECT ACCOUNT] ❌ Ошибка подключения аккаунта:', error);
            showNotificationMessage('❌ Ошибка при подключении аккаунта. Попробуйте еще раз.', 'error');
        } finally {
            setIsConnecting(false);
        }
    };


    // Отключение аккаунта
    const disconnectAccount = async () => {
        if (!selectedConnection) return;

        setIsDisconnecting(true);

        try {
            const response = await AdminService.deleteAccountStudent(selectedConnection.id);

            if (response.success) {
                closeAllModals();
                showNotificationMessage(
                    `Аккаунт успешно отвязан от ученика ${selectedStudent.ferstName} ${selectedStudent.lastName}!`,
                    'success'
                );
                await loadData();
            } else {
                closeAllModals();
                showNotificationMessage(
                    'Ошибка при отвязке аккаунта: ' + (response.message || 'Неизвестная ошибка'),
                    'error'
                );
            }
        } catch (error) {
            logger.error('Ошибка отвязки аккаунта:', error);
            closeAllModals();
            showNotificationMessage('Ошибка при отвязке аккаунта. Попробуйте еще раз.', 'error');
        } finally {
            setIsDisconnecting(false);
        }
    };

    // Изменение подключенного аккаунта
    const updateConnection = async () => {
        if (!selectedConnection || !selectedMinecraftAccount) return;

        // ✅ НОВАЯ ПРОВЕРКА НА ДУБЛИРОВАНИЕ (исключаем текущего студента)
        const existingConnection = isAccountAlreadyConnected(
            selectedMinecraftAccount.id,
            selectedStudent.id
        );
        if (existingConnection) {
            const connectedStudent = getStudentByConnection(selectedMinecraftAccount.id);
            showNotificationMessage(
                `❌ Аккаунт "${selectedMinecraftAccount.firstName}" уже подключен к ученику "${connectedStudent?.ferstName} ${connectedStudent?.lastName}". Выберите другой аккаунт.`,
                'error'
            );
            return;
        }

        setIsUpdating(true);

        try {
            const response = await AdminService.updateAccountStudentOwner(selectedConnection.id, {
                idUserMinecraftia: selectedMinecraftAccount.id
            });

            if (response.success) {
                closeAllModals();
                showNotificationMessage(
                    `✅ Аккаунт ученика "${selectedStudent.ferstName} ${selectedStudent.lastName}" успешно изменен на "${selectedMinecraftAccount.firstName}"!`,
                    'success'
                );
                await loadData();
            } else {
                showNotificationMessage(
                    '❌ Ошибка при изменении аккаунта: ' + (response.message || 'Неизвестная ошибка'),
                    'error'
                );
            }
        } catch (error) {
            logger.error('Ошибка изменения аккаунта:', error);
            showNotificationMessage('❌ Ошибка при изменении аккаунта. Попробуйте еще раз.', 'error');
        } finally {
            setIsUpdating(false);
        }
    };


    if (loading) {
        return (
            <div className={cl.pagewrapper}>
                <Spinner size="large" text="Загрузка аккаунтов" fullPage />
            </div>
        );
    }

    if (error) {
        return (
            <div className={cl.pagewrapper}>
                <div className={cl.wrapcontent1}>
                    <div className={cl.errorState}>
                        <h2>Ошибка загрузки</h2>
                        <p>{error}</p>
                        <button className={cl.retryButton} onClick={loadData}>
                            Попробовать снова
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const notConnectedCount = students.length - accountStudents.length;

    return (
        <div className={cl.pagewrapper} ref={topRef}>
            <div className={cl.wrapcontent1}>
                {/* Шапка-карточка */}
                <div className={cl.pageHeaderV2}>
                    <div className={cl.pageHeaderLeft}>
                        <div className={cl.pageHeaderIcon}>
                            <IconAccounts width={22} height={22}/>
                        </div>
                        <div className={cl.pageHeaderText}>
                            <div className={cl.pageHeaderTopRow}>
                                <h1 className={cl.pageHeaderTitle}>Аккаунты учеников</h1>
                                <span className={cl.pageHeaderPill}>
                                    <span className={cl.pageHeaderPillStrong}>{students.length}</span>
                                    <span className={cl.pageHeaderPillMuted}>
                                        {students.length === 1 ? 'ученик' : 'учеников'}
                                    </span>
                                </span>
                                <span className={`${cl.pageHeaderPill} ${cl.pageHeaderPillActive}`}>
                                    <span className={cl.pageHeaderPillDot}/>
                                    <span className={cl.pageHeaderPillStrong}>{accountStudents.length}</span>
                                    <span className={cl.pageHeaderPillMuted}>подключено</span>
                                </span>
                                {notConnectedCount > 0 && (
                                    <span className={cl.pageHeaderPill}>
                                        <span className={cl.pageHeaderPillStrong}>{notConnectedCount}</span>
                                        <span className={cl.pageHeaderPillMuted}>не подключено</span>
                                    </span>
                                )}
                            </div>
                            <div className={cl.breadcrumbs}>
                                АдминПанель · Аккаунты · Ученики Майнкрафтии
                            </div>
                        </div>
                    </div>
                    <div className={cl.pageHeaderActions}>
                        <button
                            onClick={loadData}
                            className={cl.btnGhostV2}
                            title="Обновить"
                        >
                            <IconRefresh width={15} height={15}/>
                        </button>
                    </div>
                </div>

                <PageIntro
                    storageKey="account-students"
                    title="О странице «Аккаунты учеников»"
                    text="Здесь вы связываете ученика из журнала с его аккаунтом в школе Майнкрафтия. После связки за решённые задачи и проекты ученик получает алмазы и рейтинг в своём профиле, а вы видите его прогресс."
                    bullets={[
                        '«Подключить аккаунт» — ищет пользователя Майнкрафтии по нику и привязывает к ученику',
                        'Один аккаунт Майнкрафтии можно привязать только к одному ученику в журнале',
                        'Клик на «Подключён» — заменить аккаунт или отвязать привязку',
                        'После подключения ученику автоматически активируется подписка на курсы Майнкрафтии',
                    ]}
                />

                {/* Уведомления */}
                {showNotification && (
                    <div className={`${cl.notificationV2} ${cl[notificationStatus]}`}>
                        <span className={cl.notificationIconV2}>
                            {notificationStatus === 'success'
                                ? <IconCheck width={16} height={16}/>
                                : <IconAlert width={16} height={16}/>}
                        </span>
                        <span className={cl.notificationMessage}>{notificationMessage}</span>
                        <button
                            className={cl.notificationCloseV2}
                            onClick={() => setShowNotification(false)}
                            aria-label="Закрыть"
                        >
                            <IconClose width={14} height={14}/>
                        </button>
                    </div>
                )}

                {/* Поиск */}
                <div className={cl.searchContainerV2}>
                    <span className={cl.searchIconV2}>
                        <IconSearch width={18} height={18}/>
                    </span>
                    <input
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Поиск по имени, возрасту, статусу или нику в Майнкрафтии…"
                        className={cl.searchInputV2}
                    />
                    {searchTerm && (
                        <button
                            className={cl.clearSearchV2}
                            onClick={() => setSearchTerm('')}
                            aria-label="Очистить"
                        >
                            <IconClose width={14} height={14}/>
                        </button>
                    )}
                </div>

                {/* Таблица студентов */}
                <div className={cl.tableCard}>

                    <div className={cl.tableContainer}>
                        <table className={cl.studentsTable}>
                            <thead>
                                <tr>
                                    <th
                                        onClick={() => handleSort('name')}
                                        className={cl.sortableHeader}
                                    >
                                        Ученик{getSortIcon('name')}
                                    </th>
                                    <th
                                        onClick={() => handleSort('age')}
                                        className={cl.sortableHeader}
                                    >
                                        Возраст{getSortIcon('age')}
                                    </th>
                                    <th
                                        onClick={() => handleSort('status')}
                                        className={cl.sortableHeader}
                                    >
                                        Статус журнала{getSortIcon('status')}
                                    </th>
                                    <th
                                        onClick={() => handleSort('connection')}
                                        className={cl.sortableHeader}
                                    >
                                        Подключение к Майнкрафтии{getSortIcon('connection')}
                                    </th>
                                    <th>Действия</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredStudents.map(student => {
                                    const connection = getAccountConnection(student.id);
                                    const minecraftProfile = connection ? minecraftProfiles[connection.idUserMinecraftia] : null;

                                    return (
                                        <tr key={student.id}>
                                            {/* Информация об ученике */}
                                            <td className={cl.studentCell} data-label="Ученик">
                                                <div className={cl.studentInfo}>
                                                    <div className={cl.studentName}>
                                                        {student.ferstName} {student.lastName}
                                                    </div>

                                                </div>
                                            </td>

                                            {/* Возраст */}
                                            <td className={cl.ageCell} data-label="Возраст" style={{ textAlign: 'center' }}>
                                                {student.age || 'Не указан'}
                                            </td>

                                            {/* Статус в журнале */}
                                            <td className={cl.statusCell} data-label="Статус" style={{ textAlign: 'center' }}>
                                                <span className={student.status === 'Активен' ? cl.statusActive : cl.statusInactive}>
                                                    {student.status}
                                                </span>
                                            </td>

                                            {/* Статус подключения к майнкрафтии */}
                                            <td className={cl.connectionCell} data-label="Майнкрафтия">
                                                {connection && minecraftProfile ? (
                                                    <div className={cl.connectedProfile}>
                                                        <div className={cl.profileHeader}>
                                                            <img
                                                                src={minecraftProfile.photo ? FOLDER_PROFILE + minecraftProfile.photo : ava}
                                                                alt="Avatar"
                                                                className={cl.profileAvatar}
                                                            />
                                                            <div className={cl.profileInfo}>
                                                                <div className={cl.profileName}>
                                                                    {minecraftProfile.firstName}
                                                                </div>
                                                                <div className={cl.profileLevel}>
                                                                    Уровень {minecraftProfile.level}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={cl.profileStats}>
                                                            <img style={{ height: 16 }} src={diamond} alt="" />
                                                            <span className={cl.diamonds}>
                                                                {minecraftProfile.diamond}
                                                            </span>
                                                            <img style={{ height: 16 }} src={rating} alt="" />
                                                            <span className={cl.rating}>
                                                                {minecraftProfile.rating}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : connection ? (
                                                    <div className={cl.connectionError}>
                                                        <span className={cl.errorIcon}>
                                                            <IconAlert width={14} height={14}/>
                                                        </span>
                                                        <span>Ошибка загрузки профиля</span>
                                                    </div>
                                                ) : (
                                                    <div className={cl.notConnected}>
                                                        <span className={cl.notConnectedIcon}>
                                                            <IconClose width={14} height={14}/>
                                                        </span>
                                                        <span>Не подключён</span>
                                                    </div>
                                                )}
                                            </td>

                                            {/* Действия */}
                                            <td className={cl.actionsCell} data-label="">
                                                {connection ? (
                                                    <button
                                                        className={`${cl.connectedBadge} ${cl.editButton}`}
                                                        onClick={() => openEditConnectionModal(student)}
                                                    >
                                                        <span className={cl.defaultText}>
                                                            <IconCheck width={14} height={14}/>
                                                            <span>Подключён</span>
                                                        </span>
                                                        <span className={cl.hoverText}>
                                                            <IconGamepad width={14} height={14}/>
                                                            <span>Изменить</span>
                                                        </span>
                                                    </button>
                                                ) : (
                                                    <button
                                                        className={cl.connectButton}
                                                        onClick={() => openConnectModal(student)}
                                                    >
                                                        <IconGamepad width={14} height={14}/>
                                                        <span>Подключить аккаунт</span>
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        {filteredStudents.length === 0 && (
                            <div className={cl.noResults}>
                                <p>Нет результатов по запросу "{searchTerm}"</p>
                                <button
                                    className={cl.clearSearchButton}
                                    onClick={() => setSearchTerm('')}
                                >
                                    Очистить поиск
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {/* Модальное окно подключения */}
                {showModal && (
                    <div className={cl.modalOverlay} onClick={closeAllModals}>
                        <div className={cl.modal} onClick={e => e.stopPropagation()}>
                            <div className={cl.modalHeader}>
                                <div className={cl.modalTitleWrap}>
                                    <span className={cl.modalTitleIcon}>
                                        <IconGamepad width={18} height={18}/>
                                    </span>
                                    <h3 className={cl.modalTitle}>
                                        Подключить аккаунт Майнкрафтии
                                    </h3>
                                </div>
                                <button className={cl.modalClose} onClick={closeAllModals} aria-label="Закрыть">
                                    <IconClose width={18} height={18}/>
                                </button>
                            </div>

                            <div className={cl.modalContent}>
                                {selectedStudent && (
                                    <div className={cl.selectedStudentInfo}>
                                        <h4>Выбранный ученик:</h4>
                                        <div className={cl.studentCard}>
                                            <strong>{selectedStudent.ferstName} {selectedStudent.lastName}</strong>
                                            <span>Возраст: {selectedStudent.age}</span>
                                        </div>
                                    </div>
                                )}

                                {/* Поле поиска */}
                                <div className={cl.searchSection}>
                                    <h4>Найти аккаунт в Майнкрафтии:</h4>
                                    <div className={cl.searchInputContainer}>
                                        <span className={cl.modalSearchIcon}>
                                            <IconSearch width={16} height={16}/>
                                        </span>
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            placeholder="Введите имя пользователя…"
                                            className={cl.searchInput}
                                        />
                                        {isSearching && (
                                            <span className={cl.searchSpinner}>
                                                <IconRefresh width={14} height={14}/>
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* Результаты поиска */}
                                {searchResults.length > 0 && (
                                    <div className={cl.searchResults}>
                                        <h5>Найденные пользователи:</h5>
                                        <div className={cl.userCards}>
                                            {searchResults.map(user => (
                                                <div
                                                    key={user.id}
                                                    className={`${cl.userCard} ${selectedMinecraftAccount?.id === user.id ? cl.selected : ''}`}
                                                    onClick={() => selectMinecraftAccount(user)}
                                                >
                                                    <img
                                                        src={user.photo ? FOLDER_PROFILE + user.photo : ava}
                                                        alt="Avatar"
                                                        className={cl.userAvatar}
                                                    />
                                                    <div className={cl.userInfo}>
                                                        <div className={cl.userName}>{user.firstName}</div>
                                                        <div className={cl.userLevel}>Уровень {user.level}</div>
                                                        <div style={{ marginTop: 4 }} className={cl.userStats}>
                                                            <img style={{ height: 12 }} src={diamond} alt="" />
                                                            <span> {user.diamond}</span>
                                                            <img style={{ height: 14, marginLeft: 4 }} src={rating} alt="" />
                                                            <span> {user.rating}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Выбранный аккаунт для подтверждения */}
                                {selectedMinecraftAccount && (
                                    <div className={cl.confirmationSection}>
                                        <h4>Подтвердите подключение:</h4>
                                        <div className={cl.confirmationCard}>
                                            <div className={cl.selectedAccount}>
                                                <img
                                                    src={selectedMinecraftAccount.photo ? FOLDER_PROFILE + selectedMinecraftAccount.photo : ava}
                                                    alt="Avatar"
                                                    className={cl.confirmAvatar}
                                                />
                                                <div className={cl.confirmInfo}>
                                                    <strong>{selectedMinecraftAccount.firstName}</strong>
                                                    <div>Уровень {selectedMinecraftAccount.level}</div>
                                                    {/* <div>💎 {selectedMinecraftAccount.diamond} ⭐ {selectedMinecraftAccount.rating}</div> */}
                                                    <div style={{ marginTop: 4, fontSize: 14 }} className={cl.userStats}>
                                                        <img style={{ height: 16 }} src={diamond} alt="" />
                                                        <span> {selectedMinecraftAccount.diamond}</span>
                                                        <img style={{ height: 16, marginLeft: 4 }} src={rating} alt="" />
                                                        <span> {selectedMinecraftAccount.rating}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={cl.confirmText}>
                                                Вы точно хотите подключить этот аккаунт к ученику
                                                <strong> {selectedStudent?.ferstName} {selectedStudent?.lastName}</strong>?
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Кнопки действий */}
                            <div className={cl.modalActions}>
                                <button
                                    className={cl.cancelButton}
                                    onClick={closeAllModals}
                                >
                                    Отмена
                                </button>
                                <button
                                    className={cl.confirmButton}
                                    onClick={connectAccount}
                                    disabled={!selectedMinecraftAccount || isConnecting}
                                >
                                    {isConnecting ? 'Подключаем…' : 'Подключить аккаунт'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Модальное окно управления подключением */}
                {editConnectionModal && selectedConnection && (
                    <div className={cl.modalOverlay} onClick={closeAllModals}>
                        <div className={cl.modal} onClick={e => e.stopPropagation()}>
                            <div className={cl.modalHeader}>
                                <div className={cl.modalTitleWrap}>
                                    <span className={cl.modalTitleIcon}>
                                        <IconGamepad width={18} height={18}/>
                                    </span>
                                    <h3 className={cl.modalTitle}>
                                        Управление подключением
                                    </h3>
                                </div>
                                <button className={cl.modalClose} onClick={closeAllModals} aria-label="Закрыть">
                                    <IconClose width={18} height={18}/>
                                </button>
                            </div>

                            <div className={cl.modalContent}>
                                <div className={cl.currentConnectionInfo}>
                                    <h4>К ученику {selectedStudent?.ferstName} {selectedStudent?.lastName} подключен аккаунт:</h4>

                                    {minecraftProfiles[selectedConnection.idUserMinecraftia] && (
                                        <div className={cl.currentAccountCard}>
                                            <div className={cl.accountHeader}>
                                                <img
                                                    src={minecraftProfiles[selectedConnection.idUserMinecraftia].photo ? FOLDER_PROFILE + minecraftProfiles[selectedConnection.idUserMinecraftia].photo : ava}
                                                    // src={getAvatarUrl(minecraftProfiles[selectedConnection.idUserMinecraftia].photo)}
                                                    alt="Avatar"
                                                    className={cl.currentAvatar}
                                                />

                                                <div className={cl.accountInfo}>
                                                    <div className={cl.userName}>{minecraftProfiles[selectedConnection.idUserMinecraftia].firstName}</div>
                                                    <div className={cl.userLevel}>Уровень {minecraftProfiles[selectedConnection.idUserMinecraftia].level}</div>
                                                    <div style={{ marginTop: 4 }} className={cl.userStats}>
                                                        <img style={{ height: 12 }} src={diamond} alt="" />
                                                        <span> {minecraftProfiles[selectedConnection.idUserMinecraftia].diamond}</span>
                                                        <img style={{ height: 14, marginLeft: 4 }} src={rating} alt="" />
                                                        <span> {minecraftProfiles[selectedConnection.idUserMinecraftia].rating}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className={cl.connectionActions}>
                                        <button
                                            className={cl.disconnectButton}
                                            onClick={() => setShowDisconnectConfirm(true)}
                                        >
                                            <IconClose width={14} height={14}/>
                                            <span>Отвязать аккаунт</span>
                                        </button>
                                    </div>
                                </div>

                                {/* Подтверждение отвязки */}
                                {showDisconnectConfirm && (
                                    <div className={cl.confirmDisconnectSection}>
                                        <div className={cl.confirmDisconnectCard}>
                                            <div className={cl.confirmDisconnectHead}>
                                                <span className={cl.confirmDisconnectIcon}>
                                                    <IconAlert width={18} height={18}/>
                                                </span>
                                                <h4>Подтверждение отвязки</h4>
                                            </div>
                                            <p>Вы точно хотите отвязать аккаунт от ученика?</p>
                                            <div className={cl.confirmDisconnectActions}>
                                                <button
                                                    className={cl.cancelButton}
                                                    onClick={() => setShowDisconnectConfirm(false)}
                                                >
                                                    Отмена
                                                </button>
                                                <button
                                                    className={cl.confirmDisconnectButton}
                                                    onClick={disconnectAccount}
                                                    disabled={isDisconnecting}
                                                >
                                                    {isDisconnecting ? 'Отвязываем…' : 'Отвязать аккаунт'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Поиск нового аккаунта для замены */}
                                {!showDisconnectConfirm && (
                                    <>
                                        <div className={cl.replaceSection}>
                                            <h4>Или подключить другой аккаунт:</h4>
                                            <div className={cl.searchInputContainer}>
                                                <span className={cl.modalSearchIcon}>
                                                    <IconSearch width={16} height={16}/>
                                                </span>
                                                <input
                                                    type="text"
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    placeholder="Введите имя нового пользователя…"
                                                    className={cl.searchInput}
                                                />
                                                {isSearching && (
                                                    <span className={cl.searchSpinner}>
                                                        <IconRefresh width={14} height={14}/>
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/* Результаты поиска для замены */}
                                        {searchResults.length > 0 && (
                                            <div className={cl.searchResults}>
                                                <h5>Найденные пользователи:</h5>
                                                <div className={cl.userCards}>
                                                    {searchResults.map(user => (
                                                        <div
                                                            key={user.id}
                                                            className={`${cl.userCard} ${selectedMinecraftAccount?.id === user.id ? cl.selected : ''}`}
                                                            onClick={() => selectMinecraftAccount(user)}
                                                        >
                                                            <img
                                                                src={user.photo ? FOLDER_PROFILE + user.photo : ava}
                                                                alt="Avatar"
                                                                className={cl.confirmAvatar}
                                                            />
                                                            <div className={cl.confirmInfo}>
                                                                <strong>{user.firstName}</strong>
                                                                <div>Уровень {user.level}</div>
                                                                {/* <div>💎 {selectedMinecraftAccount.diamond} ⭐ {selectedMinecraftAccount.rating}</div> */}
                                                                <div style={{ marginTop: 4, fontSize: 14 }} className={cl.userStats}>
                                                                    <img style={{ height: 16 }} src={diamond} alt="" />
                                                                    <span> {user.diamond}</span>
                                                                    <img style={{ height: 16, marginLeft: 4 }} src={rating} alt="" />
                                                                    <span> {user.rating}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* Подтверждение замены аккаунта */}
                                        {selectedMinecraftAccount && (
                                            <div className={cl.replaceConfirmSection}>
                                                <h4>Подтвердите замену аккаунта:</h4>
                                                <div className={cl.replaceConfirmCard}>
                                                    <div className={cl.selectedAccount}>

                                                        <img
                                                            src={selectedMinecraftAccount.photo ? FOLDER_PROFILE + selectedMinecraftAccount.photo : ava}
                                                            alt="Avatar"
                                                            className={cl.confirmAvatar}
                                                        />
                                                        <div className={cl.confirmInfo}>
                                                            <strong>{selectedMinecraftAccount.firstName}</strong>
                                                            <div>Уровень {selectedMinecraftAccount.level}</div>
                                                            {/* <div>💎 {selectedMinecraftAccount.diamond} ⭐ {selectedMinecraftAccount.rating}</div> */}
                                                            <div style={{ marginTop: 4, fontSize: 14 }} className={cl.userStats}>
                                                                <img style={{ height: 16 }} src={diamond} alt="" />
                                                                <span> {selectedMinecraftAccount.diamond}</span>
                                                                <img style={{ height: 16, marginLeft: 4 }} src={rating} alt="" />
                                                                <span> {selectedMinecraftAccount.rating}</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className={cl.confirmText}>
                                                        Заменить текущий аккаунт на этот для ученика
                                                        <strong> {selectedStudent?.ferstName} {selectedStudent?.lastName}</strong>?
                                                    </div>
                                                </div>
                                                <div className={cl.replaceActions}>
                                                    <button
                                                        className={cl.cancelButton}
                                                        onClick={() => setSelectedMinecraftAccount(null)}
                                                        style={{ marginRight: 20 }}
                                                    >
                                                        Отмена
                                                    </button>
                                                    <button
                                                        className={cl.confirmButton}
                                                        onClick={updateConnection}
                                                        disabled={isUpdating}
                                                    >
                                                        {isUpdating ? 'Обновляем…' : 'Подключить другой аккаунт'}
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                            {!showDisconnectConfirm && !selectedMinecraftAccount && (
                                <div className={cl.modalActions}>
                                    <button
                                        className={cl.cancelButton}
                                        onClick={closeAllModals}
                                    >
                                        Закрыть
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AccountStufents;